import { ethers } from 'ethers';

export const shortAddr = (addr) => {
  if (!addr) return '';
  return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
};

export const formatUSDT = (val, decimals = 2) => {
  if (!val) return '0.00';
  try {
    const num = parseFloat(ethers.utils.formatUnits(val.toString(), 18));
    return num.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  } catch {
    return '0.00';
  }
};

export const toBN = (val) => {
  try {
    return ethers.utils.parseUnits(val.toString(), 18);
  } catch {
    return ethers.BigNumber.from(0);
  }
};

export const fromBN = (val) => {
  if (!val) return 0;
  try {
    return parseFloat(ethers.utils.formatUnits(val.toString(), 18));
  } catch {
    return 0;
  }
};

export const formatDate = (ts) => {
  if (!ts) return '-';
  const d = new Date(Number(ts) * 1000);
  return d.toLocaleString('en-US', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  });
};

export const formatDateShort = (ts) => {
  if (!ts) return '-';
  const d = new Date(Number(ts) * 1000);
  return d.toLocaleDateString('en-US', {
    day: '2-digit', month: 'short', year: '2-digit'
  });
};

export const timeAgo = (ts) => {
  if (!ts) return '';
  const now = Math.floor(Date.now() / 1000);
  const diff = now - Number(ts);
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

export const pct = (val, denom = 10000) => {
  const n = Number(val || 0) / denom;
  return `${(n * 100).toFixed(2)}%`;
};

export const actTypeLabel = (t) => {
  const map = {
    1: 'INVEST', 2: 'ROI', 3: 'LEVEL', 4: 'APPROVED',
    5: 'BOOSTER', 6: 'REQUEST', 7: 'REJECTED'
  };
  return map[t] || 'UNKNOWN';
};

export const actTypeColor = (t) => {
  const map = {
    1: 'accent', 2: 'success', 3: 'primary', 4: 'success',
    5: 'success', 6: 'warning', 7: 'danger'
  };
  return map[t] || 'muted';
};

export const invTypeLabel = (t) => {
  const map = { 0: 'REAL', 1: 'VIRTUAL', 2: 'LEADER' };
  return map[t] || 'UNKNOWN';
};

export const withdrawStatusLabel = (s) => {
  const n = Number(s);
  return n === 0 ? 'PENDING' : n === 1 ? 'APPROVED' : n === 2 ? 'REJECTED' : 'UNKNOWN';
};

export const withdrawStatusBadge = (s) => {
  const n = Number(s);
  return n === 0 ? 'badge-warning' : n === 1 ? 'badge-success' : n === 2 ? 'badge-danger' : 'badge-muted';
};
